import { render, staticRenderFns } from "./collection-card.vue?vue&type=template&id=2f461027&"
import script from "./collection-card.ts?vue&type=script&lang=ts&"
export * from "./collection-card.ts?vue&type=script&lang=ts&"
import style0 from "./collection-card.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports